import {Widget} from "@bryntum/schedulerpro";
// Todo: check later for build there's an extra config for vite
//  https://stackoverflow.com/questions/73180352/how-can-i-use-a-custom-build-of-ckeditor-5-with-react-and-vite
import CustomCkEditorInstance from "ckeditor-custom-build";
import {SWIVU_RICH_TEXT_EDITOR_CLS} from "../../../other/constants/OtherKeys.jsx";

// the function returns an element with all required classname applied to it.
export const getBodyWrapperRootEl = () => {
  const p1 = document.createElement("div")
  const p1Child = document.createElement("div");
  p1.className = "ck-body-wrapper";
  p1Child.className = "ck ck-reset_all ck-body ck-rounded-corners";
  p1Child.dir = "ltr";
  p1.appendChild(p1Child);
  document.querySelector(`.${SWIVU_RICH_TEXT_EDITOR_CLS}`).appendChild(p1);
  return p1Child;
}

export class SwivuRichTextEditorWidget extends Widget {
  static get $name() {
    return "SwivuRichTextEditorWidget";
  }

  static get type() {
    return "swivurichtexteditorwidget";
  }

  static get configurable() {
    return {
      listeners: {
        paint: "onWidgetPaint",
        beforeDestroy: "onWidgetBeforeDestroy",
      }
    }
  }

  onWidgetBeforeDestroy() {
    this.swivuCkEditorInstance.destroy();
  }

  onWidgetPaint({ firstPaint, source }) {
    if (firstPaint) {
      const editorWrapperEl = source.element;
      this.swivuCKEditorInitPromise = CustomCkEditorInstance
        .create(editorWrapperEl)
        .then((editor) => {
          // default ckeditor render floating toolbar buttons (image, link toolbar buttons) in the body root, but since we're rendering
          // ckeditor in bryntum's modal (with modal backdrop to true) the click event on those toolbar buttons doesn't work, as internally bryntum
          // ignore those events. to make it work, I just move those toolbar buttons inside the bryntum editor hierarchy.

          // BodyCollection - is the area where ckeditor put all floating toolbar button e.g, image, link toolbar buttons
          editor.ui.view.body.setParent(getBodyWrapperRootEl());
          this.swivuOnEditorInit(editor)
        })
        .catch((error) => {
          console.error(error, "==Error: ck-editor==");
        });
    }
  }

  swivuOnEditorInit(editor) {
    this.swivuCkEditorInstance = editor;
    if (this.swivuCkEditorDefaultHeight) {
      this.swivuResizeEditor(0, this.swivuCkEditorDefaultHeight);
      delete this.swivuCkEditorDefaultHeight;
    }
    editor.editing.view.focus();
  }

  swivuSetNoteData(data) {
    this.swivuCkEditorInstance.setData(data);
  }

  swivuGetNoteData() {
    return this.swivuCkEditorInstance.getData();
  }

  swivuSetNoteReadOnly(isReadOnly) {
    if (isReadOnly) {
      this.swivuCkEditorInstance.enableReadOnlyMode( 'swivu-editor-readonly');
    } else {
      this.swivuCkEditorInstance.disableReadOnlyMode( 'swivu-editor-readonly');
    }
  }

  swivuAddNotChangeListener(cb) {
    this.swivuCkEditorInstance.model.document.on( 'change:data', cb);
  }

  swivuResizeEditor(_newWidth, newHeight) {
    if (this.swivuCkEditorInstance) {
      this.swivuCkEditorInstance.editing.view.change((writer) => {
        const toolbarHeight = this.swivuCkEditorInstance.ui.view.toolbar.element.clientHeight || 0;
        writer.setStyle("height", `${newHeight - toolbarHeight}px`, this.swivuCkEditorInstance.editing.view.document.getRoot());
      });
    } else {
      // on first call swivuCkEditorInstance may be null in that case we need to retain height to effect after editor init successfully
      this.swivuCkEditorDefaultHeight = newHeight;
    }
  }

  swivuGetEditorTitle() {
    if (this.swivuCkEditorInstance) {
      return this.swivuCkEditorInstance.plugins.get("Title").getTitle();
    }
  }

  swivuAddWordCountChangeListener(cb) {
    const wordCountPlugin = this.swivuCkEditorInstance.plugins.get("WordCount");
    wordCountPlugin.on("update", cb);
  }

  swivuGetWordCount() {
    if (this.swivuCkEditorInstance) {
      const wordCountPlugin = this.swivuCkEditorInstance.plugins.get("WordCount");
      return { words: wordCountPlugin.words, characters: wordCountPlugin.characters };
    }
  }
}

SwivuRichTextEditorWidget.initClass();

// Todo: remove later
// editor.ui.view.editable.element.style.minHeight = "25em";
// swivuCkEditorInstance.enableReadOnlyMode("my-feature-id")
// swivuCkEditorInstance.disableReadOnlyMode("my-feature-id")

// The statement below does not work properly as we focus out from editor the height gets reset
// this.swivuCkEditorInstance.ui.view.editable.element.style.minHeight = `${newHeight}px`;

// plugins: [Mention],
// enable but hids behind bryntum editor search through "ck ck-balloon-panel ck-balloon-panel_caret_ne ck-balloon-panel_visible"
// instead of hardcoding z-index set `z-index: var(--ck-z-modal);` to --ck-z-modal variable

/*
{
          mention: {
            feeds: [
              // todo: for temporary remove later
              {
                marker: '@',
                feed: [ '@Barney', '@Lily', '@Marry Ann', '@Marshall', '@Robin', '@Ted' ],
                minimumCharacters: 0
              }
            ]
          }
        }
* */

// https://ckeditor.com/docs/ckeditor5/latest/installation/getting-started/getting-and-setting-data.html#autosave-feature

// https://ckeditor.com/docs/ckeditor5/latest/features/autosave.html